import { supabase } from '@/lib/supabase'

const CACHE_TTL_MS = 2 * 60 * 1000

type CacheEntry = {
  enabled: boolean
  fetchedAt: number
}

const cacheByUserId = new Map<string, CacheEntry>()
const inflightByUserId = new Map<string, Promise<boolean>>()

function normalizeUserId(userId: string | null | undefined): string {
  return String(userId || '').trim()
}

export function invalidateCommunityModeratorEnabledCache(userId?: string | null) {
  const id = normalizeUserId(userId)
  if (id) {
    cacheByUserId.delete(id)
    inflightByUserId.delete(id)
    return
  }
  cacheByUserId.clear()
  inflightByUserId.clear()
}

export async function fetchCommunityModeratorEnabled(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc(
      'user_community_moderator_enabled' as any,
    )
    if (error) {
      // eslint-disable-next-line no-console
      console.error('user_community_moderator_enabled error', error)
      return false
    }
    return Boolean(data)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('user_community_moderator_enabled error', e)
    return false
  }
}

export async function getCommunityModeratorEnabledCached(
  userId: string | null,
): Promise<boolean> {
  const id = normalizeUserId(userId)
  if (!id) return false

  const now = Date.now()
  const cached = cacheByUserId.get(id)
  if (cached && now - cached.fetchedAt < CACHE_TTL_MS) return cached.enabled

  const inflight = inflightByUserId.get(id)
  if (inflight) return inflight

  const promise = (async () => {
    const enabled = await fetchCommunityModeratorEnabled()
    cacheByUserId.set(id, { enabled, fetchedAt: Date.now() })
    inflightByUserId.delete(id)
    return enabled
  })().catch((err) => {
    // eslint-disable-next-line no-console
    console.error('getCommunityModeratorEnabledCached error', err)
    cacheByUserId.set(id, { enabled: false, fetchedAt: Date.now() })
    inflightByUserId.delete(id)
    return false
  })

  inflightByUserId.set(id, promise)
  return promise
}

